import React, {useRef, useState, useEffect} from 'react'
import clx from 'classnames'
import Translator from '../translator'
import { LabeledInputField } from '../inputs/LabeledInputField'
import { RootStore } from '../../datastores/rootStore'
import { ValidateCouponController } from '../../datastores/validateCouponController'
import { ValidateCartController } from '../../datastores/validateCartController'
import { runInAction } from 'mobx'

export const CouponCodeField = function Button({}) {
  const [showCouponField, setShowCouponField] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [needsRemoveConfirmation, setNeedsRemoveConfirmation] = useState(false)

  const ref = useRef(null)
  const inputRef = useRef(null)
  const removeRef = useRef(null)

  let cart = RootStore.getInstance().cart

  const applyCoupon = async () => {
    setIsLoading(true)

    let isCouponValid = await ValidateCouponController.getInstance().validate(inputValue)

    if(!isCouponValid) {
      setMessage(Translator.translate('Rabatkoden er ikke gyldig', 'cart-overview'))

      setIsLoading(false)
      return
    }

    runInAction(() => {
      cart.coupon = inputValue
      cart.couponTitle = ValidateCouponController.getInstance().couponTitle ?? inputValue
    })

    await cart.validateContent()

    setShowCouponField(false)

    setIsLoading(false)
  }

  const handleRemoveCoupon = () => {
    if(needsRemoveConfirmation) {
      setNeedsRemoveConfirmation(false)
      removeCoupon()
    } else {
      setNeedsRemoveConfirmation(true)
    }
  }

  const removeCoupon = () => {
    setIsLoading(true)

    runInAction(() => {
      cart.coupon = null
      cart.couponTitle = null
    })

    cart.validateContent()
    setIsLoading(false)
  }

  const handleClickOutside = (e) => {
    if (showCouponField && !ref.current.contains(e.target) && inputValue === '') {
      setShowCouponField(false)
    }

    if(!removeRef.current?.contains(e.target)) {
      setNeedsRemoveConfirmation(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if(showCouponField) {
      inputRef.current.focus()
    }
  }, [showCouponField])

  useEffect(() => {
    async function validateExistingCoupon() {
      if(cart.coupon) {
        let isCouponValid = await ValidateCouponController.getInstance().validate(cart.coupon)

        if(!isCouponValid) {
          cart.coupon = null
          cart.couponTitle = null
          cart.validateContent()
        } else {
          runInAction(() => {
            cart.couponTitle = ValidateCouponController.getInstance().couponTitle ?? cart.couponTitle
          })
        }
      }
    }

    validateExistingCoupon()
  }, [])

  return (
    <div className='mtt-coupon-code-field' ref={ref}>
      {cart.coupon ? (
        <div className='mtt-coupon-code-field__coupon'>
          <span>{cart.couponTitle ?? cart.coupon}</span>
          <button
            ref={removeRef}
            onClick={handleRemoveCoupon}
            className={clx({ 'active' : needsRemoveConfirmation })}
          >{needsRemoveConfirmation ? Translator.translate('Fjern rabatkode?', 'cart-overview') : null}</button>
        </div>
      ) : (
        <>
          <div className='mtt-coupon-code-field__button-wrapper'>
            <span className={clx('mtt-coupon-code-field__button', {'open' : showCouponField})} onClick={() => setShowCouponField(!showCouponField)}>
              { Translator.translate('Tilføj rabatkode', 'cart-overview') }
            </span>
          </div>
          { showCouponField ? (
            <div className={clx("mtt-coupon-code-field__input", { 'loading' : isLoading })}>
              <LabeledInputField
                labelText={Translator.translate('Rabatkode', 'cart-overview')}
                id='coupon_code'
                type='text'
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    applyCoupon()
                  }
                }}
                value={inputValue}
                onChange={(e) => {
                  setInputValue(e.target.value)
                  setMessage('')
                }}
                forwardedRef={inputRef}
                disabled={isLoading}
                errorMessage={message}
                forceErrorDisplay={message !== ''}
              />
              <button
                onClick={applyCoupon}
                disabled={isLoading || inputValue === ''}
                className={clx("button", { 'loading' : isLoading })}
              >{Translator.translate('Tilføj', 'cart-overview')}</button>
            </div>
          ) : null }
        </>
      )}
    </div>
  )
}